import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import { API_ERROR_MAP } from 'types'
import { PAYMENT_STAGE, logPaymentFailed } from 'uxcam-service'

const useSetupIntentManager = ({
  accountHerokuId,
  contactHerokuId,
  fetchStripeSetupIntent,
  flashErrorMessage,
  stripeCustomerId = null,
}) => {
  const stripeSetupIntent = useSelector(memberSelectors.stripeSetupIntent)

  const create = useCallback(async () => {
    if (stripeSetupIntent?.setup_intent_id) return

    try {
      await fetchStripeSetupIntent({
        stripeCustomerId,
        accountHerokuId,
        contactHerokuId,
      })
    } catch (error) {
      logPaymentFailed(PAYMENT_STAGE.SETUP_INTENT, error)
      flashErrorMessage(API_ERROR_MAP.ERROR_PROCESSING_PAYMENT)
    }
  }, [
    accountHerokuId,
    contactHerokuId,
    fetchStripeSetupIntent,
    flashErrorMessage,
    stripeCustomerId,
    stripeSetupIntent?.setup_intent_id,
  ])

  return {
    create,
    setupIntentId: stripeSetupIntent?.setup_intent_id ?? null,
    clientSecret: stripeSetupIntent?.client_secret ?? null,
    customerSessionSecret:
      stripeSetupIntent?.customer_session_client_secret ?? null,
  }
}

export default useSetupIntentManager
